import { TimeBlock } from '../Model';

export const calculateEquipmentSummary = (timeBlocks: TimeBlock[]): Record<string, number> => {
  const maxPerKey: Record<string, number> = {};

  timeBlocks.forEach((block) => {
    const blockTotals: Record<string, number> = {};

    block.drillGroups.forEach((group) => {
      const stationCount = group.stations.length;
      Object.entries(group.drill.equipment).forEach(([key, qty]) => {
        blockTotals[key] = (blockTotals[key] || 0) + qty * stationCount;
      });
    });

    Object.entries(blockTotals).forEach(([key, total]) => {
      maxPerKey[key] = Math.max(maxPerKey[key] || 0, total);
    });
  });

  return maxPerKey;
};
